<template>
  <div id="nav">
    <RouterView v-slot="{ Component }">
      <keep-alive>
        <component
          :key="$route.pullPath"
          :is="Component"
          v-if="$route.meta.keepAlive == true"
        />
      </keep-alive>
      <component
        :key="$route.pullPath"
        v-if="!$route.meta.keepAlive != true"
        :is="Component"
      />
    </RouterView>
    <router-view />
  </div>
</template>
<script setup>
import { reactive } from "vue";
const state = reactive();
</script>

<style lang="scss">
#app {
  font-size: 14px;
}
</style>
